// extracted by mini-css-extract-plugin
export var employeePhoto = "styles-module--employeePhoto--P3EG6";
export var photoContainer = "styles-module--photoContainer--5LIX5";